/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Ente } from '@ideapa/app-shared-ente';
import { Modulo } from '@ideapa/app-shared-modulo';
import {
  LoginDto,
  LoginResponseDto,
  TokenDto,
  UserWithEntiDto,
} from '@ideapa/common-dto';
import { MFAMethodEnum } from '@ideapa/common-utils';
import { createAction, props } from '@ngrx/store';

export const getLoggedUser = createAction(`[Auth] Get logged user`);

export const getLoggedUserSuccess = createAction(
  `[Auth] Get logged user success`,
  props<{ loggedUser: UserWithEntiDto }>()
);

export const getLoggedUserFail = createAction(
  `[Auth] Get logged user fail`,
  props<{ error: string }>()
);

export const logout = createAction(`[Auth] Logout`);
export const logoutSuccess = createAction(`[Auth] Logout success`);
export const logoutFailure = createAction(
  `[Auth] Logout failure`,
  props<{ error: string }>()
);
export const setUserMustResetPassword = createAction(
  '[Auth] User must reset password'
);

export const loginWithAAD = createAction(
  `[Auth] AAD Login`,
  props<{ rememberMe: boolean }>()
);
export const loginWithAADSuccess = createAction(
  '[Auth] AAD Login Success',
  props<{ result: TokenDto }>()
);
export const loginWithAADFailure = createAction(
  '[Auth] AAD Login Failure',
  props<{ error: string }>()
);

export const login = createAction(
  '[Auth] Login',
  props<{
    username: string;
    password: string;
    rememberMe: boolean;
    newPassword?: string;
  }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ result: TokenDto }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string; userMustResetPassword?: boolean }>()
);

export const forgotPassword = createAction(
  '[Auth] Forgot password',
  props<{ username: string }>()
);
export const forgotPasswordSuccess = createAction(
  '[Auth] Forgot password Success'
);
export const forgotPasswordFailure = createAction(
  '[Auth] Forgot password Failure',
  props<{ error: string }>()
);

export const resetPassword = createAction(
  '[Auth] Reset password submit',
  props<{ token: string; newPassword: string }>()
);
export const resetPasswordSuccess = createAction(
  '[Auth] Reset password submit Success'
);
export const resetPasswordFailure = createAction(
  '[Auth] Reset password submit Failure',
  props<{ error: string }>()
);

export const sessionExpired = createAction(`[Auth] SessionExpired`);

//CheckAuth
export const checkAADAuth = createAction('[Auth] Check auth');
export const checkAuthSuccess = createAction(
  '[Auth] Check auth success',
  props<{ loggedIn: boolean }>()
);
export const checkAuthFail = createAction(
  '[Auth] Check auth fail',
  props<{ error: string }>()
);

export const forceRefresh = createAction('[Auth] Force refresh');
export const forceRefreshSucces = createAction(
  '[Auth] Force refresh success',
  props<{ result: TokenDto }>()
);
export const forceRefreshFail = createAction(
  '[Auth] Force refresh fail',
  props<{ error: string }>()
);

export const resetAuthError = createAction('[Auth] Reset auth error');

export const clearModulo = createAction('[Auth] Clear modulo');

export const showSelectModuloPopup = createAction(
  '[Auth] Show Select modulo popup',
  props<{ modulo: Modulo | null }>()
);

export const selectModulo = createAction(
  '[Auth] Select modulo',
  props<{ modulo: Modulo; prevModulo: Modulo | null }>()
);

export const selectEnte = createAction(
  '[Auth] Select ente',
  props<{ ente: Ente; prevEnte: Ente | null }>()
);

export const selectAnno = createAction(
  '[Auth] Select anno',
  props<{ anno: number; prevAnno: number | null }>()
);

export const showChangePasswordPopup = createAction(
  '[Auth] Show Change Password popup'
);

export const changePassword = createAction(
  '[Auth] Change password',
  props<{
    password: string;
    newPassword: string;
  }>()
);

export const changePasswordSuccess = createAction(
  '[Auth] Change Password Success'
);

export const changePasswordFailure = createAction(
  '[Auth] Change Password Failure',
  props<{ error: string }>()
);

// MFA actions
export const setupMA = createAction(
  '[Auth] Setup Microsoft Authenticator',
  props<{ result: LoginResponseDto }>()
);
export const insertMAOTP = createAction(
  '[Auth] Insert MA OTP Code',
  props<{ result: LoginResponseDto }>()
);
export const verifyMAOTP = createAction(
  '[Auth] Verify Microsoft Authenticator OTP',
  props<{ otpCode: string; loginResponse: LoginResponseDto }>()
);
export const verifyMAOTPSuccess = createAction(
  '[Auth] Verify Microsoft Authenticator OTP Success',
  props<{ result: TokenDto }>()
);
export const verifyMAOTPFailure = createAction(
  '[Auth] Verify Microsoft Authenticator OTP Failure',
  props<{ error: string }>()
);

export const checkLoginResponse = createAction('[Auth] Check Login Response');

export const missingLoginResponse = createAction(
  '[Auth] Missing Login Response'
);

export const setLoginResponse = createAction(
  '[Auth] Set Login Response',
  props<{ loginResponse: LoginResponseDto }>()
);

export const insertEmailOTP = createAction(
  '[Auth] Insert Email OTP Code',
  props<{ result: LoginResponseDto }>()
);

export const verifyEmailOTP = createAction(
  '[Auth] Verify Email OTP',
  props<{ otpCode: string; loginResponse: LoginResponseDto }>()
);
export const verifyEmailOTPSuccess = createAction(
  '[Auth] Verify Email OTP Success',
  props<{ result: TokenDto }>()
);
export const verifyEmailOTPFailure = createAction(
  '[Auth] Verify Email OTP Failure',
  props<{ error: string }>()
);

export const chooseMFA = createAction(
  '[Auth] Choose MFA method',
  props<{ result: LoginResponseDto }>()
);
export const proceedToMFAMethod = createAction(
  '[Auth] Proceed to MFA method',
  props<{
    loginData: LoginDto;
    method: MFAMethodEnum;
    loginResponse: LoginResponseDto;
  }>()
);

export const proceedToMFAMethodSuccess = createAction(
  '[Auth] Proceed to MFA method Success'
);
export const proceedToMFAMethodFailure = createAction(
  '[Auth] Proceed to MFA method Failure',
  props<{ error: string }>()
);
